import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizeDatePipe } from './localize-date.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LocalizeDatePipe],
  exports: [LocalizeDatePipe]
})
export class LocalizeDateModule { }



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/date-localization/localize-date.module.ts